import React, {useContext, useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {Form, Formik} from 'formik';
import {Button, Card, Grid} from '@mui/material';
import {acquisitionInitialValue, acquisitionValidation} from './AcquisitionModel';
import AcquisitionEntryOne from './AcquisitionEntryOne';
import AcquisitionEntryTwo from './AcquisitionEntryTwo';
import AcquisitionEntryThree from './AcquisitionEntryThree';
import {MultipleImageUpload} from '../../../common/ImageUpload/MultipleImage';
import {useNavigate} from 'react-router';
import {acquisitionsAction, acquisitionsApi} from '../../../services/AcquisitionServices';
import {DispatchContext} from '../../../store';
import {SNACKBAR_OPEN} from '../../../reducers';
import {mastersApi} from '../../../services/MasterDataServices';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

export default function AddAcquisition() {
  const dispatch = useContext(DispatchContext);
  const user = JSON.parse(localStorage.getItem('user'));
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const id = params.get('id');
  const isEdit = params.get('isEdit');
  const [initialValues, setInitialValues] = useState(acquisitionInitialValue);
  const [acquisitionImgIds, setAcquisitionImgIds] = useState([]);
  const [masters, setMasters] = useState({acquisitions: []});
  const code = 'en';

  useEffect(() => {
    mastersApi('acquisitions', 'get').then((res) => {
      setMasters({acquisitions: res?.data || res || []});
    });

    if (id) {
      acquisitionsAction('get', id).then(res => {
        setInitialValues({
          ...res?.data,
          acquisition_type_id: res?.data?.acquisition_type?.id ?? res?.data?.acquisition_type_id ?? null,
          date_of_entry: res?.data?.date_of_entry,
          dzongkhag_id: res?.data?.dzongkhag_id,
          gewog_id: res?.data?.gewog_id,
          village_id: res?.data?.village_id,
          price: res?.data?.price,
          appraised_value: res?.data?.appraised_value,
          attachment_ids: [],
          translations: {
            en: {
              owner: res?.data?.owner,
              chiwog: res?.data?.chiwog,
              received_from: res?.data?.received_from,
              permanent_address: res?.data?.permanent_address,
              storage: res?.data?.storage,
              location: res?.data?.location
            }
          }
        })
      })
    }
  },[id]);

  const onSubmit = (values, {setSubmitting}) => {
    const combinedAttachments = (values?.attachments || []).concat(acquisitionImgIds ? acquisitionImgIds : []);

    const uniqueIdsSet = new Set();

    combinedAttachments.forEach(id => {
      const parsedId = parseInt(id);
      const parsedIdFromObj = parseInt(id?.id);

      if (!isNaN(parsedId)) {
        uniqueIdsSet.add(parsedId);
      }

      if (!isNaN(parsedIdFromObj)) {
        uniqueIdsSet.add(parsedIdFromObj);
      }
    });

    const newAttachmentIds = Array.from(uniqueIdsSet);

    const acquisitionData = {
      museum_id: user?.museums?.[0]?.id,
      acquisition_type_id: values?.acquisition_type_id,
      date_of_entry: values?.date_of_entry,
      dzongkhag_id: values?.dzongkhag_id,
      gewog_id: values?.gewog_id,
      village_id: values?.village_id,
      price: values?.price,
      appraised_value: values?.appraised_value,
      attachment_ids: newAttachmentIds,
      translations: values?.translations,
    }

    if (id) {
      acquisitionsAction('put', id,{...acquisitionData}).then(res => {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {
          isNotify: true,
          severity: 'success',
          message: 'Acquisition updated successfully',
        },
      })
      navigate('/management/acquisition');
    })
    } else {
      acquisitionsApi('post', {...acquisitionData}).then(res => {
        dispatch({
          type: SNACKBAR_OPEN,
          payload: {
            isNotify: true,
            severity: 'success',
            message: 'Acquisition created successfully',
          },
        })
        navigate('/management/acquisition');
      })
    }
    setSubmitting(false);
  }

  const handleGoBack = () => {
    navigate(-1);
  }

  return (
    <PageWrapper>
      <Typography sx={{marginTop: 6}} className={'museum-font'}>
        {isEdit ? 'Edit Acquisition' : 'Add Acquisition'}
      </Typography>
      <Box className={'header-divider'}/>
      <Formik initialValues={initialValues}
              onSubmit={onSubmit} validationSchema={acquisitionValidation}
              validateOnBlur={true} enableReinitialize
      >
        {({isSubmitting, touched, errors, values, setFieldValue, ...formik}) => (
          <Form>
            <Box sx={{mb: {sm: 4, xs: 2}}}>
              <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                  <AcquisitionEntryOne code={code} masters={masters}/>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <AcquisitionEntryTwo code={code}/>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <AcquisitionEntryThree code={code}/>
                </Grid>
              </Grid>
              <Box className={'dotted-divider'}/>
              <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                  <Card className={'box-shadow'} sx={{p: 4}}>
                    <MultipleImageUpload setImageId={setAcquisitionImgIds} imgId={id} acquisitionImgIds={acquisitionImgIds}/>
                  </Card>
                </Grid>
              </Grid>
            </Box>
            <Grid container spacing={2}>
              <Grid item sm={8} xs={6}/>
              <Grid item sm={2} xs={12}>
                <Button fullWidth onClick={handleGoBack} variant={'outlined'} color={'error'}
                        className={'text-capitalize'}>CANCEL</Button>
              </Grid>
              <Grid item sm={2} xs={12}>
                <Button fullWidth variant={'contained'} type={'submit'}
                        className={'text-capitalize'}>{isEdit ? 'UPDATE' : 'SUBMIT'}</Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </PageWrapper>
  );
}